const sponsors = [
  {
    name: 'AudioPro',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20geometric%20logo%20design%20for%20AudioPro%20audio%20equipment%20company%2C%20clean%20lines%2C%20modern%20professional%20style%2C%20dark%20background%20with%20vibrant%20accent%2C%20tech%20company%20branding%2C%20no%20text%2C%20simple%20elegant%20shapes&width=320&height=160&seq=sponsor-audiopro&orientation=landscape',
  },
  {
    name: 'TecnoSound',
    logo: 'https://readdy.ai/api/search-image?query=Clean%20modern%20minimalist%20logo%20design%20for%20TecnoSound%20technology%20company%2C%20abstract%20geometric%20shapes%20with%20sound%20wave%20motif%2C%20professional%20corporate%20style%2C%20dark%20background%2C%20subtle%20gradient%20accent%2C%20no%20text%2C%20sleek%20simple%20branding&width=320&height=160&seq=sponsor-tecnosound&orientation=landscape',
  },
  {
    name: 'MusicStream',
    logo: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20music%20streaming%20logo%20design%2C%20abstract%20sound%20waves%20forming%20circular%20shape%2C%20modern%20technology%20aesthetic%2C%20dark%20background%2C%20vibrant%20warm%20accent%20color%2C%20clean%20simple%20corporate%20branding%2C%20no%20text&width=320&height=160&seq=sponsor-musicstream&orientation=landscape',
  },
  {
    name: 'RadioNet',
    logo: 'https://readdy.ai/api/search-image?query=Professional%20minimalist%20broadcast%20network%20logo%20design%2C%20abstract%20radio%20tower%20symbol%20with%20signal%20waves%2C%20clean%20modern%20corporate%20style%2C%20dark%20background%2C%20bold%20accent%20color%2C%20sleek%20technology%20branding%2C%20no%20text&width=320&height=160&seq=sponsor-radionet&orientation=landscape',
  },
  {
    name: 'Eventos Plus',
    logo: 'https://readdy.ai/api/search-image?query=Minimalist%20event%20production%20company%20logo%20design%2C%20abstract%20stage%20or%20spotlight%20geometric%20mark%2C%20modern%20creative%20style%2C%20dark%20background%2C%20energetic%20accent%20color%2C%20clean%20elegant%20branding%2C%20no%20text&width=320&height=160&seq=sponsor-eventosplus&orientation=landscape',
  },
  {
    name: 'Sonido Digital',
    logo: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20audio%20company%20logo%20design%2C%20abstract%20speaker%20or%20equalizer%20geometric%20shape%2C%20sleek%20technology%20style%2C%20dark%20background%2C%20sophisticated%20accent%20color%2C%20clean%20corporate%20branding%2C%20no%20text&width=320&height=160&seq=sponsor-sonidodigital&orientation=landscape',
  },
  {
    name: 'StreamPro',
    logo: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20streaming%20technology%20logo%20design%2C%20abstract%20flowing%20data%20or%20signal%20paths%2C%20modern%20professional%20style%2C%20dark%20background%2C%20dynamic%20accent%20color%2C%20clean%20simple%20corporate%20mark%2C%20no%20text&width=320&height=160&seq=sponsor-streampro&orientation=landscape',
  },
  {
    name: 'MediaLab',
    logo: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20media%20technology%20lab%20logo%20design%2C%20abstract%20laboratory%20flask%20merged%20with%20play%20button%20symbol%2C%20creative%20modern%20style%2C%20dark%20background%2C%20innovative%20accent%20color%2C%20sleek%20branding%2C%20no%20text&width=320&height=160&seq=sponsor-medialab&orientation=landscape',
  },
];

export default function SponsorsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-violet-100 text-violet-700 text-xs font-semibold mb-4">
            <i className="ri-hand-heart-line text-xs"></i>
            Sponsors
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
            Marcas que confían en{' '}
            <span className="text-primary-600">Radio Frecuencia</span>
          </h2>
          <p className="mt-2 text-foreground-500 text-sm max-w-lg mx-auto">
            Empresas líderes que impulsan la plataforma y apoyan a nuestras comunidades de radio.
          </p>
        </div>

        {/* Logo grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
          {sponsors.map((sponsor) => (
            <div
              key={sponsor.name}
              className="group bg-background-50 rounded-2xl border border-background-200 p-5 flex items-center justify-center cursor-pointer hover:border-primary-200 hover:shadow-md transition-all duration-300"
            >
              <div className="w-full aspect-[2/1] relative flex items-center justify-center">
                <img
                  src={sponsor.logo}
                  alt={sponsor.name}
                  className="w-full h-full object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <p className="text-sm text-foreground-500 mb-4">
            ¿Querés que tu marca aparezca aquí?
          </p>
          <a
            href="#planes"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector('#planes');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-xs font-semibold rounded-xl transition-colors cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/20"
          >
            Ser Sponsor
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>
      </div>
    </section>
  );
}